import { useFetch } from "../../../hooks/api";

export const useAMCQueryData = () => {
  const { data, isLoading } = useFetch(
    ["subscribedAMCQueries"],
    "/amc/subscriptions",
    {},
    {
      select: (res) => {
        return res.data.results ?? [];
      },
      default: [],
    },
  );

  return { data, isLoading };
};
